import Vue from 'vue'

// 数据可视化组件
// 进度条组件
Vue.component('progress-chart', {
  props: {
    percentage: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 300
    }
  },
  template: `
    <div class="progress-chart-container" :style="{height: height + 'px'}">
      <h3 v-if="title" class="chart-title">{{ title }}</h3>
      <div ref="chart" class="chart-container"></div>
    </div>
  `,
  mounted() {
    this.initChart()
  },
  watch: {
    percentage() {
      this.updateChart()
    }
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$refs.chart)
      this.updateChart()
      
      // 响应式调整
      window.addEventListener('resize', () => {
        this.chart.resize()
      })
    },
    updateChart() {
      const option = {
        series: [
          {
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: true,
              clip: false,
              itemStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#7957d5'
                    },
                    {
                      offset: 1,
                      color: '#3273dc'
                    }
                  ]
                }
              }
            },
            axisLine: {
              lineStyle: {
                width: 20,
                color: [
                  [1, 'rgba(0,0,0,0.1)']
                ]
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            data: [
              {
                value: this.percentage,
                name: '完成度',
                title: {
                  offsetCenter: ['0%', '0%']
                },
                detail: {
                  offsetCenter: ['0%', '35%']
                }
              }
            ],
            title: {
              fontSize: 14,
              color: '#999'
            },
            detail: {
              width: 50,
              height: 14,
              fontSize: 28,
              color: '#7957d5',
              formatter: '{value}%'
            }
          }
        ]
      }
      this.chart.setOption(option)
    }
  }
})

// 关键词热度图组件
Vue.component('keyword-heatmap', {
  props: {
    data: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 400
    }
  },
  template: `
    <div class="keyword-heatmap-container" :style="{height: height + 'px'}">
      <h3 v-if="title" class="chart-title">{{ title }}</h3>
      <div ref="chart" class="chart-container"></div>
    </div>
  `,
  mounted() {
    this.initChart()
  },
  watch: {
    data() {
      this.updateChart()
    }
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$refs.chart)
      this.updateChart()
      
      // 响应式调整
      window.addEventListener('resize', () => {
        this.chart.resize()
      })
    },
    updateChart() {
      const option = {
        tooltip: {
          position: 'top',
          formatter: function (params) {
            return `关键词: ${params.data[0]}<br>搜索量: ${params.data[1]}<br>竞争度: ${params.data[2]}`
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.data.map(item => item[0]),
          axisLabel: {
            interval: 0,
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          name: '搜索量',
          nameLocation: 'end'
        },
        visualMap: {
          min: 0,
          max: 10,
          calculable: true,
          orient: 'horizontal',
          left: 'center',
          bottom: '0%',
          text: ['高竞争', '低竞争'],
          inRange: {
            color: ['#3273dc', '#7957d5', '#ff3860']
          }
        },
        series: [
          {
            name: '关键词热度',
            type: 'bar',
            data: this.data.map(item => [item[0], item[1], item[2]]),
            itemStyle: {
              color: function(params) {
                const value = params.data[2]
                return {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: value < 3 ? '#3273dc' : value < 7 ? '#7957d5' : '#ff3860'
                    },
                    {
                      offset: 1,
                      color: value < 3 ? '#3273dc' : value < 7 ? '#7957d5' : '#ff3860'
                    }
                  ]
                }
              }
            }
          }
        ]
      }
      this.chart.setOption(option)
    }
  }
})

// 数据趋势图组件
Vue.component('trend-chart', {
  props: {
    data: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 400
    }
  },
  template: `
    <div class="trend-chart-container" :style="{height: height + 'px'}">
      <h3 v-if="title" class="chart-title">{{ title }}</h3>
      <div ref="chart" class="chart-container"></div>
    </div>
  `,
  mounted() {
    this.initChart()
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.updateChart()
      }
    }
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$refs.chart)
      this.updateChart()
      
      // 响应式调整
      window.addEventListener('resize', () => {
        this.chart.resize()
      })
    },
    updateChart() {
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: Object.keys(this.data.series),
          top: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.data.xAxis
        },
        yAxis: {
          type: 'value'
        },
        series: Object.keys(this.data.series).map(key => ({
          name: key,
          type: 'line',
          data: this.data.series[key],
          smooth: true,
          showSymbol: false,
          areaStyle: {
            opacity: 0.1
          }
        }))
      }
      this.chart.setOption(option)
    }
  }
})

// 交互式测验组件
Vue.component('interactive-quiz', {
  props: {
    questions: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: '知识检测'
    }
  },
  data() {
    return {
      currentQuestion: 0,
      answers: [],
      submitted: false,
      score: 0
    }
  },
  template: `
    <div class="interactive-quiz-container">
      <h3 class="quiz-title">{{ title }}</h3>
      
      <div v-if="!submitted" class="quiz-questions">
        <div class="question-progress">
          <span>问题 {{ currentQuestion + 1 }}/{{ questions.length }}</span>
          <el-progress :percentage="(currentQuestion + 1) / questions.length * 100" :stroke-width="8"></el-progress>
        </div>
        
        <div class="question-container animate__animated animate__fadeIn">
          <h4 class="question-text">{{ questions[currentQuestion].question }}</h4>
          
          <div class="options-container">
            <el-radio-group v-model="answers[currentQuestion]">
              <el-radio 
                v-for="(option, index) in questions[currentQuestion].options" 
                :key="index" 
                :label="index"
                class="option-item"
              >
                {{ option }}
              </el-radio>
            </el-radio-group>
          </div>
          
          <div class="question-actions">
            <el-button 
              v-if="currentQuestion > 0" 
              @click="prevQuestion" 
              icon="el-icon-arrow-left"
            >
              上一题
            </el-button>
            <el-button 
              v-if="currentQuestion < questions.length - 1" 
              type="primary" 
              @click="nextQuestion" 
              :disabled="answers[currentQuestion] === undefined"
            >
              下一题
            </el-button>
            <el-button 
              v-else 
              type="success" 
              @click="submitQuiz" 
              :disabled="answers[currentQuestion] === undefined"
            >
              提交
            </el-button>
          </div>
        </div>
      </div>
      
      <div v-else class="quiz-results animate__animated animate__fadeIn">
        <div class="result-header">
          <h4>测验结果</h4>
          <div class="score-display">
            <div class="score-circle" :class="scoreClass">{{ score }}/{{ questions.length }}</div>
            <p>{{ scoreMessage }}</p>
          </div>
        </div>
        
        <div class="result-details">
          <div 
            v-for="(question, qIndex) in questions" 
            :key="qIndex"
            class="result-item"
            :class="{ correct: answers[qIndex] === question.correctAnswer, incorrect: answers[qIndex] !== question.correctAnswer }"
          >
            <div class="result-question">
              <span class="question-number">{{ qIndex + 1 }}.</span>
              <span>{{ question.question }}</span>
            </div>
            <div class="result-answer">
              <div v-if="answers[qIndex] === question.correctAnswer" class="correct-answer">
                <i class="el-icon-success"></i>
                <span>正确答案: {{ question.options[question.correctAnswer] }}</span>
              </div>
              <div v-else class="incorrect-answer">
                <i class="el-icon-error"></i>
                <span>您的答案: {{ question.options[answers[qIndex]] }}</span>
                <div class="correct-answer-text">
                  正确答案: {{ question.options[question.correctAnswer] }}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="result-actions">
          <el-button type="primary" @click="resetQuiz">重新测试</el-button>
        </div>
      </div>
    </div>
  `,
  computed: {
    scoreClass() {
      const percentage = this.score / this.questions.length
      if (percentage >= 0.8) return 'excellent'
      if (percentage >= 0.6) return 'good'
      return 'needs-improvement'
    },
    scoreMessage() {
      const percentage = this.score / this.questions.length
      if (percentage >= 0.8) return '太棒了！您已经掌握了这部分内容！'
      if (percentage >= 0.6) return '不错！您对这部分内容有了基本的了解。'
      return '继续加油！建议您重新学习这部分内容。'
    }
  },
  methods: {
    nextQuestion() {
      if (this.currentQuestion < this.questions.length - 1) {
        this.currentQuestion++
      }
    },
    prevQuestion() {
      if (this.currentQuestion > 0) {
        this.currentQuestion--
      }
    },
    submitQuiz() {
      this.score = 0
      this.questions.forEach((question, index) => {
        if (this.answers[index] === question.correctAnswer) {
          this.score++
        }
      })
      this.submitted = true
      
      // 触发完成事件
      this.$emit('completed', {
        score: this.score,
        total: this.questions.length
      })
    },
    resetQuiz() {
      this.currentQuestion = 0
      this.answers = []
      this.submitted = false
      this.score = 0
    }
  }
})

// 添加全局样式
const style = document.createElement('style')
style.innerHTML = `
  .chart-title {
    text-align: center;
    margin-bottom: 20px;
    color: #7957d5;
  }
  
  .chart-container {
    width: 100%;
    height: 100%;
  }
  
  .interactive-quiz-container {
    background-color: #f5f7fa;
    border-radius: 10px;
    padding: 25px;
    margin: 30px 0;
  }
  
  .dark-mode .interactive-quiz-container {
    background-color: #1a1a2e;
  }
  
  .quiz-title {
    font-size: 20px;
    margin-bottom: 20px;
    color: #7957d5;
  }
  
  .question-progress {
    margin-bottom: 20px;
  }
  
  .question-text {
    font-size: 18px;
    margin-bottom: 20px;
    color: #333;
  }
  
  .dark-mode .question-text {
    color: #f0f0f0;
  }
  
  .options-container {
    margin-bottom: 30px;
  }
  
  .option-item {
    display: block;
    margin-bottom: 15px;
    padding: 10px;
    border-radius: 5px;
    transition: all 0.3s ease;
  }
  
  .option-item:hover {
    background-color: rgba(121, 87, 213, 0.1);
  }
  
  .dark-mode .option-item:hover {
    background-color: rgba(121, 87, 213, 0.2);
  }
  
  .question-actions {
    display: flex;
    justify-content: space-between;
  }
  
  .quiz-results {
    padding: 20px;
  }
  
  .result-header {
    text-align: center;
    margin-bottom: 30px;
  }
  
  .score-display {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
  }
  
  .score-circle {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 15px;
  }
  
  .score-circle.excellent {
    background-color: rgba(103, 194, 58, 0.2);
    color: #67c23a;
  }
  
  .score-circle.good {
    background-color: rgba(64, 158, 255, 0.2);
    color: #409eff;
  }
  
  .score-circle.needs-improvement {
    background-color: rgba(230, 162, 60, 0.2);
    color: #e6a23c;
  }
  
  .result-item {
    margin-bottom: 20px;
    padding: 15px;
    border-radius: 5px;
  }
  
  .result-item.correct {
    background-color: rgba(103, 194, 58, 0.1);
  }
  
  .result-item.incorrect {
    background-color: rgba(245, 108, 108, 0.1);
  }
  
  .result-question {
    margin-bottom: 10px;
    font-weight: bold;
  }
  
  .question-number {
    margin-right: 10px;
  }
  
  .correct-answer {
    color: #67c23a;
    display: flex;
    align-items: center;
  }
  
  .incorrect-answer {
    color: #f56c6c;
    display: flex;
    flex-direction: column;
  }
  
  .incorrect-answer i {
    margin-right: 10px;
  }
  
  .correct-answer i {
    margin-right: 10px;
  }
  
  .correct-answer-text {
    margin-top: 5px;
    color: #67c23a;
  }
  
  .result-actions {
    text-align: center;
    margin-top: 30px;
  }
`
document.head.appendChild(style)
